import { Component, OnInit } from '@angular/core';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {SharedService} from '../shared.service';
import {NotificationDialogueComponent} from './notification-dialogue/notification-dialogue.component';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

  constructor(private sharedService: SharedService, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.sharedService.notificationSubject.subscribe(
      (notification) => {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.panelClass = 'full-width-dialog';
        dialogConfig.disableClose = true;
        dialogConfig.data = {
          notification
        };
        const dialogRef = this.dialog.open(NotificationDialogueComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            result.callback();
          }
        });
      }
    );
  }

}
